<template>
  <v-sheet class="params-sheet" color="grey lighten-4">
    <template v-for="({ name, value }, index) in items">
      <span :key="index" class="params-sheet__item">
        <span class="params-sheet__item-name">{{ name }}:</span>
        <span class="params-sheet__value">{{ value }}</span>
      </span>
    </template>
  </v-sheet>
</template>

<script>
export default {
  name: 'AccParamsDetails',

  props: {
    items: {
      type: Array,
      default: () => []
    }
  }
};
</script>

<style lang="scss">
.params-sheet {
  display: flex;

  & &__item {
    flex: 1;
    margin-bottom: 0;
    padding-left: 0.4rem;
  }

  & &__item {
    font-size: 1rem;
  }

  & &__item-name {
    margin-right: 0.4rem;
    font-weight: bold;
  }
}
</style>
